import service from "./goartRequest";

export function getGoartConfig(sn: string) {
  return service({
    url: "/api/config",
    method: "get",
  });
}
